/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Different types of promotions
 */
export enum PromotionTypeEnum {
  /**
   * A promotion that is applied to the first purchase of a user
   */
  FIRST_PURCHASE = "FIRST_PURCHASE"
}
